import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	BreakpointWidth,
} from '@app/enumerations';

const styles = (theme: Theme) => {
	return createStyles({
		CATLoginInfo_body: {
			margin: '0px',
			display: 'flex',
			flexDirection: 'row',
		},
		CATLoginInfo_signoutBody: {
			[theme.breakpoints.down(BreakpointWidth.SMALL)]: {
				marginRight: '0px',
			},
			[theme.breakpoints.up(BreakpointWidth.SMALL)]: {
				marginRight: '15px',
			},
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		CATLoginInfo_btnRoot: {
			padding: '0px',
			backgroundColor: 'transparent',
			boxShadow: 'none',
			cursor: 'pointer',
			minWidth: 'unset',
			borderRadius: '0px',
			'&:hover': {
				backgroundColor: 'transparent',
				boxShadow: 'none',
				transition: `${theme.transitions.duration.standard}ms ease-in-out`,
				color: theme.palette.grey[400],
			},
			textDecoration: 'underline',
			transition: `${theme.transitions.duration.standard}ms ease-in-out`,
			color: theme.palette.info.main,
			textTransform: 'capitalize',
			fontSize: '0.7em',
			whiteSpace: 'nowrap',
			justifyContent: 'flex-start',
		},
		CATLoginInfo_lblRoot: {
			textDecoration: 'none',
			color: theme.palette.info.main,
			textTransform: 'capitalize',
			fontSize: '0.8em',
			whiteSpace: 'normal',
			justifyContent: 'flex-start',
		},
		CATLoginInfo_avatarIconRoot: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				width: '40px',
				height: '40px',
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				width: '45px',
				height: '45px',
			},
			fill: theme.palette.grey[400],
		},
		CATLoginInfo_avatarRoot: {
			[theme.breakpoints.down(BreakpointWidth.SMALL)]: {
				display: 'none',
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				height: '40px',
			},
			width: 'auto',
			height: 'auto',
			backgroundColor: theme.palette.background.default,
		},
		CATLoginInfo_avatarLoginStatus: {
			position: 'absolute',
			height: theme.spacing(1.5),
			width: theme.spacing(1.5),
			borderRadius: '50%',
			border: `2px solid ${theme.palette.common.white}`,
			bottom: theme.spacing(.75),
			right: theme.spacing(.5),
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				height: theme.spacing(1.25),
				width: theme.spacing(1.25),
				bottom: theme.spacing(.5),
				right: theme.spacing(.25),
			},
		},
		CATLoginInfo_avatarLoginStatusCCUser: {
			backgroundColor: theme.palette.success.main,
		},
		CATLoginInfo_avatarLoginStatusThirdParty: {
			backgroundColor: theme.palette.warning.main,
		},
		CATLoginInfo_loginButtonWrapper: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			height: '100%',
		},
		CATLoginInfo_optionsDropdownButton: {
			backgroundColor: 'transparent',
			boxShadow: 'none',
			cursor: 'pointer',
			minWidth: 'unset',
			borderRadius: '0px',
			'&:hover': {
				backgroundColor: 'transparent',
				boxShadow: 'none',
			},
			transition: `${theme.transitions.duration.shortest}ms ease-in-out`,
			color: theme.palette.info.main,
			textTransform: 'capitalize',
			fontSize: '0.7em',
			whiteSpace: 'nowrap',
			justifyContent: 'flex-start',
			padding: theme.spacing(.5, 0, .5, 1),
			marginLeft: theme.spacing(-1),
		},
		CATLoginInfo_optionsDropdownButtonHighlight: {
			background: theme.palette.grey[100],
			boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14)',
			'&:hover': {
				background: theme.palette.grey[100],
				boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14)',
			},
		},
		CATLoginInfo_optionsDropdownIconRoot: {
			height: '.8em',
			width: '.8em'
		},
		CATLoginInfo_optionsDropdownPaperRoot: {
			borderRadius: '0px',
			backgroundColor: theme.palette.grey[100],
			boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14)',
			color: theme.palette.info.main,
		},
		CATLoginInfo_optionsDropdownMenuListRoot: {
			paddingTop: '0px',
			paddingBottom: '0px'
		},
		CATLoginInfo_optionsDropdownMenuItemRoot: {
			fontSize: '0.7em',
			padding: theme.spacing(1),
			color: theme.palette.info.main,
		},
		CATLoginInfo_optionsDropdownPopperRoot: {
			zIndex: theme.zIndex.modal,
		},
	});
}

export default styles;
